import { createSlice } from '@reduxjs/toolkit';
import {
  getCurrencyRate,
  getClientData,
} from '../thunk/DefaultSliceThunk';

const initialState = {
  currencyRate: [],
  clientData: null,
  staticUrl: null,
  loading: false,
  error: null,
};

export const DefaultSlice = createSlice({
  name: 'default',
  initialState,
  reducers: {
    setClientData: (state, action) => {
      state.clientData = { ...state.clientData, ...action.payload };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCurrencyRate.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCurrencyRate.fulfilled, (state, action) => {
        state.loading = false;
        state.currencyRate = action.payload;
      })
      .addCase(getCurrencyRate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getClientData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClientData.fulfilled, (state, action) => {
        state.loading = false;
        state.clientData = action.payload?.clientData ?? null;
        state.staticUrl = action.payload?.staticUrl ?? null;
      })
      .addCase(getClientData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { setClientData, setAnnouncementAvailable } = DefaultSlice.actions;
export default DefaultSlice.reducer;
